import React from 'react'
import {
  Form,
  Col,
  FormGroup,
  Button,
  FormControl,
  ControlLabel,
} from 'react-bootstrap'
import ButterToast, { Cinnamon } from 'butter-toast'
import { notebook as endpoints } from '../../api_urls'
import { client } from '../../utils'
import { useStateValue } from '../../state'

const FilterForm = () => {
  let [currentState, dispatch] = useStateValue()

  const applyResetFilters = async filters => {
    let data = {
      ...currentState,
      filters: filters,
      page: 1,
    }

    try {
      let resp = await client.post(endpoints.filterHighlights(), data)
      dispatch({ type: 'updateHighlights', payload: resp.data.highlights })
      dispatch({ type: 'updateHighlightCount', payload: resp.data.hlCount })
      if (filters !== currentState.filters) {
        dispatch({ type: 'updateFilters', payload: filters })
      }
      dispatch({ type: 'updateMessage', payload: resp.data.message })
    } catch (err) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crisp
            title="Error"
            content={err.response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-thumbs-down fa-3x" />}
          />
        ),
        sticky: true,
      })
    }
  }

  const updateFilter = (evt, fltr) => {
    let filters = { ...currentState.filters }
    filters[fltr] = evt.target.value
    dispatch({ type: 'updateFilters', payload: filters })
  }

  return (
    <Form horizontal>
      <FormGroup>
        <Col componentClass={ControlLabel} smOffset={7} sm={2}>
          <b>Chapter:</b>
        </Col>
        <Col sm={7}>
          <FormControl
            componentClass="select"
            aria-label="Chapter"
            value={currentState.filters.chapter}
            onChange={e => updateFilter(e, 'chapter')}
          >
            <option value="all">All Chapters</option>
            {currentState.chapters.map((chap, i) => (
              <option value={chap[0]} key={i}>
                {chap[1]}
              </option>
            ))}
          </FormControl>
        </Col>
      </FormGroup>
      <FormGroup>
        <Col
          componentClass={ControlLabel}
          smOffset={7}
          sm={2}
          htmlFor="tagSearch"
        >
          <b>Search a Tag:</b>
        </Col>
        <Col sm={7}>
          <FormControl
            placeholder="#exampleTag"
            value={currentState.filters.tag}
            onChange={e => updateFilter(e, 'tag')}
            id="tagSearch"
          />
        </Col>
      </FormGroup>
      <FormGroup>
        <Col
          componentClass={ControlLabel}
          smOffset={7}
          sm={2}
          htmlFor="wordSearch"
        >
          <b>Search:</b>
        </Col>
        <Col sm={7}>
          <FormControl
            placeholder="Search for a word or sentence"
            value={currentState.filters.search}
            onChange={e => updateFilter(e, 'search')}
            id="wordSearch"
          />
        </Col>
      </FormGroup>
      <FormGroup>
        <Col componentClass={ControlLabel} smOffset={7} sm={2}>
          <b>Color:</b>
        </Col>
        <Col sm={7}>
          <FormControl
            componentClass="select"
            aria-label="Color"
            value={currentState.filters.color}
            onChange={e => updateFilter(e, 'color')}
          >
            <option value="">-Select a Color-</option>
            <optgroup label="Highlighted">
              {currentState.highlightColors[1].map((color, i) => (
                <option value={color[0]} key={i}>
                  {color[1]}
                </option>
              ))}
            </optgroup>
            <optgroup label="Underlined">
              {currentState.highlightColors[2].map((color, i) => (
                <option value={color[0]} key={i}>
                  {color[1]}
                </option>
              ))}
            </optgroup>
          </FormControl>
        </Col>
      </FormGroup>
      <Col smOffset={11}>
        <Button
          type="button"
          bsStyle="primary"
          className="btn-myed-sm btn-primary-myed mr-4"
          onClick={() => applyResetFilters(currentState.filters)}
        >
          Apply Filters
        </Button>
        <Button
          type="button"
          bsStyle="default"
          className="btn-myed-sm btn-defaul-myed"
          onClick={() =>
            applyResetFilters({
              chapter: 'all',
              tag: '',
              search: '',
              color: '',
            })
          }
        >
          Reset
        </Button>
      </Col>
    </Form>
  )
}

export default FilterForm
